import axios from './index';

class StoresApi {
  static List = (data) => {
    let query = '?';
    if (data.status) {
      query += `status=${data.status}&`;
    }
    if (data.storeId) {
      query = `${data.storeId}`;
    }
    if (data.companyId) {
      query += `company_id=${data.companyId}&`;
    }
    if (data.operationLocationId) {
      query += `operation_location_id=${data.operationLocationId}&`;
    }
    if (data.variantId) {
      query += `saving_plan_variant_id=${data.variantId}&`;
    }
    if (data.saving_plan_enable) {
      query += `saving_plan_enable=${data.saving_plan_enable}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    let request = {
      operation_location_id: String(data.operationLocationId),
      company_id: String(data.companyId),
      name: String(data.name),
      store_code: String(data.storeCode),
      gold_locker_enable:
        data.goldLocker || data.goldLocker === 'true' ? true : false,
      saving_plan_enable:
        data.savingPlan || data.savingPlan === 'true' ? true : false,
      email: String(data.email),
      phone_number: String(data.phoneNumber),
      country_code: String(data.countryCode),
      address_line1: String(data.addressLine1),
      address_line2: String(data.addressLine2),
      city: String(data.city),
      state: String(data.state),
      country: String(data.country),
      landmarks: String(data.landmarks),
      pincode: String(data.pincode),
      status: String(data.status),
      timing: {
        Monday: [
          {
            Start: String(data.mondayStart1),
            Finish: String(data.mondayFinish1),
          },
          {
            Start: String(data.mondayStart2),
            Finish: String(data.mondayFinish2),
          },
        ],
        Tuesday: [
          {
            Start: String(data.tuesdayStart1),
            Finish: String(data.tuesdayFinish1),
          },
          {
            Start: String(data.tuesdayStart2),
            Finish: String(data.tuesdayFinish2),
          },
        ],
        Wednesday: [
          {
            Start: String(data.wednesdayStart1),
            Finish: String(data.wednesdayFinish1),
          },
          {
            Start: String(data.wednesdayStart2),
            Finish: String(data.wednesdayFinish2),
          },
        ],
        Thursday: [
          {
            Start: String(data.thursdayStart1),
            Finish: String(data.thursdayFinish1),
          },
          {
            Start: String(data.thursdayStart2),
            Finish: String(data.thursdayFinish2),
          },
        ],
        Friday: [
          {
            Start: String(data.fridayStart1),
            Finish: String(data.fridayFinish1),
          },
          {
            Start: String(data.fridayStart2),
            Finish: String(data.fridayFinish2),
          },
        ],
        Saturday: [
          {
            Start: String(data.saturdayStart1),
            Finish: String(data.saturdayFinish1),
          },
          {
            Start: String(data.saturdayStart2),
            Finish: String(data.saturdayFinish2),
          },
        ],
        Sunday: [
          {
            Start: String(data.sundayStart1),
            Finish: String(data.sundayFinish1),
          },
          {
            Start: String(data.sundayStart2),
            Finish: String(data.sundayFinish2),
          },
        ],
      },
    };
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {
      operation_location_id: String(data.operationLocationId),
      company_id: String(data.companyId),
      name: String(data.name),
      gold_locker_enable:
        data.goldLocker || data.goldLocker === 'true' ? true : false,
      saving_plan_enable:
        data.savingPlan || data.savingPlan === 'true' ? true : false,
      email: String(data.email),
      phone_number: String(data.phoneNumber),
      country_code: String(data.countryCode),
      address_line1: String(data.addressLine1),
      address_line2: String(data.addressLine2),
      city: String(data.city),
      state: String(data.state),
      country: String(data.country),
      landmarks: String(data.landmarks),
      pincode: String(data.pincode),
      timing: {
        Monday: [
          {
            Start: String(data.mondayStart1),
            Finish: String(data.mondayFinish1),
          },
          {
            Start: String(data.mondayStart2),
            Finish: String(data.mondayFinish2),
          },
        ],
        Tuesday: [
          {
            Start: String(data.tuesdayStart1),
            Finish: String(data.tuesdayFinish1),
          },
          {
            Start: String(data.tuesdayStart2),
            Finish: String(data.tuesdayFinish2),
          },
        ],
        Wednesday: [
          {
            Start: String(data.wednesdayStart1),
            Finish: String(data.wednesdayFinish1),
          },
          {
            Start: String(data.wednesdayStart2),
            Finish: String(data.wednesdayFinish2),
          },
        ],
        Thursday: [
          {
            Start: String(data.thursdayStart1),
            Finish: String(data.thursdayFinish1),
          },
          {
            Start: String(data.thursdayStart2),
            Finish: String(data.thursdayFinish2),
          },
        ],
        Friday: [
          {
            Start: String(data.fridayStart1),
            Finish: String(data.fridayFinish1),
          },
          {
            Start: String(data.fridayStart2),
            Finish: String(data.fridayFinish2),
          },
        ],
        Saturday: [
          {
            Start: String(data.saturdayStart1),
            Finish: String(data.saturdayFinish1),
          },
          {
            Start: String(data.saturdayStart2),
            Finish: String(data.saturdayFinish2),
          },
        ],
        Sunday: [
          {
            Start: String(data.sundayStart1),
            Finish: String(data.sundayFinish1),
          },
          {
            Start: String(data.sundayStart2),
            Finish: String(data.sundayFinish2),
          },
        ],
      },
    };
    return axios.put(`${base}/${data.storeId}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.storeId}`);
  };
}

let base = 'dashboard/store';

export default StoresApi;
